import { c as _c } from "react/compiler-runtime";
import { Check, ChevronDown, FileText, LucideIcon } from "lucide-react";
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/src/components/shadcn/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/src/components/shadcn/ui/collapsible";
interface FieldsetHeaderProps {
  title: string;
  children: React.ReactNode;

  // State management (can be controlled or uncontrolled)
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  defaultOpen?: boolean;

  // Optional status indicator to show in the header
  status?: React.ReactNode;

  // For automatic conflict indicator. null indicates that conflicts don't apply.
  conflictCount?: number | null;

  // Optional icon to show in the header
  icon?: LucideIcon;
}
export default function FieldsetHeader(t0) {
  const $ = _c(27);
  const {
    title,
    children,
    isOpen: controlledIsOpen,
    onOpenChange,
    defaultOpen: t1,
    status,
    icon: t2,
    conflictCount: t3
  } = t0;
  const defaultOpen = t1 === undefined ? true : t1;
  const Icon = t2 === undefined ? FileText : t2;
  const conflictCount = t3 === undefined ? null : t3;
  const [uncontrolledIsOpen, setUncontrolledIsOpen] = useState(defaultOpen);
  const hasConflicts = conflictCount !== null && conflictCount > 0;
  const isControlled = controlledIsOpen !== undefined;
  const isOpen = isControlled ? controlledIsOpen : uncontrolledIsOpen;
  let t4;
  if ($[0] !== isControlled || $[1] !== onOpenChange) {
    t4 = open => {
      if (!isControlled) {
        setUncontrolledIsOpen(open);
      }
      if (onOpenChange) {
        onOpenChange(open);
      }
    };
    $[0] = isControlled;
    $[1] = onOpenChange;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const handleOpenChange = t4;
  let t5;
  if ($[3] !== conflictCount || $[4] !== hasConflicts || $[5] !== isOpen) {
    t5 = hasConflicts !== undefined && <>{hasConflicts && <div className="mr-2 px-2 py-0.5 text-xs bg-warn text-warn-foreground rounded-full flex items-center">{conflictCount} {conflictCount === 1 ? "Conflict" : "Conflicts"}</div>}{conflictCount === 0 && !isOpen && <div className="mr-2 px-1 py-0 text-xs bg-primary text-white dark:text-black rounded-full flex items-center justify-center w-4 h-4"><Check className="stroke-[2.5]" /></div>}</>;
    $[3] = conflictCount;
    $[4] = hasConflicts;
    $[5] = isOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const autoStatus = t5;
  const displayStatus = status || autoStatus;
  let t6;
  if ($[7] !== Icon) {
    t6 = <Icon className="mr-2 h-4 w-4 shrink-0 text-muted-foreground" />;
    $[7] = Icon;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== title) {
    t7 = <CardTitle className="truncate">{title}</CardTitle>;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className="flex items-center min-w-0 flex-1">{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== displayStatus) {
    t10 = <div className="flex items-center">{displayStatus}{t9}</div>;
    $[15] = displayStatus;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t8) {
    t11 = <CardHeader className="p-0 text-sm bg-muted hover:bg-accent space-y-0"><CollapsibleTrigger className="p-2 flex justify-between items-center w-full">{t8}{t10}</CollapsibleTrigger></CardHeader>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== children) {
    t12 = <CollapsibleContent><CardContent className="p-2">{children}</CardContent></CollapsibleContent>;
    $[20] = children;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== handleOpenChange || $[23] !== isOpen || $[24] !== t11 || $[25] !== t12) {
    t13 = <Card className="space-y-2 bg-card mx-0 px-0 rounded-none"><Collapsible open={isOpen} onOpenChange={handleOpenChange} className="w-full">{t11}{t12}</Collapsible></Card>;
    $[22] = handleOpenChange;
    $[23] = isOpen;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}